<script>
export default {
    name: "HeadCountDetailsPrint",

    data() {

        return {
            patients: [],
            headCount: {},
        };
    },

    mounted() {
        this.$root.loading=true;
        Promise.all([this.fetchHeadCountDetails(), this.fetchHeadCount(),]).then(() => {
            this.$root.loading=false;
            setTimeout(() => {
                window.print();
            }, 300);
        }).catch(() => {this.$root.loading=false;});
    },

    methods: {

        fetchHeadCountDetails() {
            let url=`HeadCountSurveilance/GetHeadCountDetails`;
                url+=`?HeadCountID=${this.$route.query.headCount}`;

            return this.$http.get(url).then(response => {
                this.patients = response.data;
            }).catch(() => {});
        },

        fetchHeadCount() {
            let url=`HeadCountSurveilance/GetSpecificHeadCount`;
                url+=`?HeadCountID=${this.$route.query.headCount}`;

            return this.$http.get(url).then(({data}) =>{
                   this.headCount = data.length ? data[0] : {}; 
                }).catch(() => {});
        },
    },
}
</script>
<template>
    <div class="w-full flex flex-wrap items-center">
        <div class="w-full p-2 text-center">
            <h5 class="text-lg uppercase">Head Count Report</h5>
        </div>
        <div class="w-full p-2">
            <h5 class="text-lg">Date: {{headCount.sysDate | dateFormatDT}}</h5>
        </div>
        <div class="w-full overflow-visible mt-2">
            <table class="table text-xs">
                <thead class="bg-blue-500 text-white">
                   <tr>
                       <th class="p-tiny">Code</th>
                       <th class="p-tiny">Patient</th>
                       <th class="p-tiny">Date Admitted</th>
                       <th class="p-tiny">Ward</th>
                       <th class="p-tiny">P Mode</th>
                       <th class="p-tiny">Count Status</th>
                       <th class="p-tiny">Comment</th>
                   </tr> 
                </thead>
                <tbody class="bg-gray-100">
                    <tr v-for="patient in patients" 
                        :class="{
                            'bg-red-300' : !patient.isPresent
                        }"
                        :key="patient.patientID">
                        <td class="p-tiny">{{patient.headCountDetailID}}</td>
                        <td class="p-tiny">
                            <h5 class="font-medium">{{patient.names}}</h5>
                            <h5 class="font-medium">MRN: {{patient.patientID}}</h5>
                            <h5 class="font-medium">IP: {{patient.ipfileno}}</h5>
                            <h5 class="font-medium">OP: {{patient.opfileno}}</h5>
                            <h5 class="font-medium">Contact: {{patient.celL_PHONE || `-`}}</h5>
                        </td>
                        <td class="p-tiny">{{patient.dateAdmitted | dateFormat}}</td>
                        <td class="p-tiny">
                            <h5 class="font-medium">Ward: {{patient.ward}}</h5>
                            <h5 class="font-medium">Bed: {{patient.bed}}</h5>
                        </td>
                        <td class="p-tiny w-32 break-words">{{patient.pmode}}</td>
                        <td class="p-tiny">{{patient.isPresent ? `Present` : `Absent`}}</td>
                        <td class="p-tiny break-words">{{patient.comment || `-`}}</td>
                    </tr>
                </tbody>
            </table>
        </div> 
        <div class="w-full p-2">
            <h5 class="font-medium text-sm">Comment:</h5>
            <p class="text-xs mt-1">{{headCount.comment || `-`}}</p>
        </div>
        <div class="w-full p-1">
            <h5 class="font-medium text-sm">Done By:</h5>
            <p class="text-xs mt-1">{{headCount.userName}}</p>
        </div>
    </div>
</template>